<header class="d-flex" >
  <div *ngFor="let item of registerItems" class="menu-cadastro">
    <a *ngIf="!isExternal(item)" [routerLink]="getItemRoute(item)" [queryParams]="getQueryParams(item)" class="btn btn-outline-white">
      <i class="fa fa-plus"></i> {{ item.key }}
    </a>
    <a *ngIf="isExternal(item)" [href]="item.value" class="btn btn-outline-white" [attr.target]="getLinkTarget(item)" rel="noopener">
      <i class="fa fa-plus"></i> {{ item.key }}
    </a>
  </div>

  <div class="menu-lista">
    <ul class="d-flex d-print-none">
      <li>
        <a routerLink="/dashboard" class="menu__link" routerLinkActive="menu__link--active">
          <i class="fas fa-chart-line"></i>
          <span class="menu__link-text">
            Início
          </span>

          <div *ngIf="existPending" class="badge badge-warning badge-pill">{{ totalPendingItems }}</div>
        </a>
      </li>
      <li *ngFor="let item of menuItems">
        <a *ngIf="!isExternal(item)" [routerLink]="getItemRoute(item)" [queryParams]="getQueryParams(item)" class="menu__link" routerLinkActive="menu__link--active">
          <i class="fas fa-folder-open"></i>
          <span class="menu__link-text">
            {{item.key}}
          </span>
        </a>
        <a *ngIf="isExternal(item)" [href]="item.value" class="menu__link" [attr.target]="getLinkTarget(item)" rel="noopener">
          <i class="fas fa-folder-open"></i>
          <span class="menu__link-text">
            {{item.key}}
          </span>
        </a>
      </li>
    </ul>
  
  
    <p *ngIf="isAdminUser">CONFIGURAÇÕES</p>
    <ul class="d-flex d-print-none">
      <li *ngIf="isAdminUser || hasPermitionToViewUsers">
        <a routerLink="/users" class="menu__link" routerLinkActive="menu__link--active">
          <i class="fas fa-user-cog"></i>
          <span class="menu__link-text">
            Usuários
          </span>
        </a>
      </li>
      <li *ngIf="isAdminUser">
        <a href="https://policies{{urlEnv}}.buildflex.io" target="_blank" class="menu__link">
          <i class="fas fa-cog"></i>
          <span class="menu__link-text">
            Studio <i class="fas fa-external-link-alt" style="font-size: 10px; margin-left: 3px;"></i>
          </span>
        </a>
      </li>
    </ul>
  </div>
</header>